// Gemeinsame Hülle für Impressum, Datenschutz, AGB und die öffentlichen
// Formulare: Kopf mit Rückweg, lesbare Textbreite, Fuß mit allen Rechtslinks.
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { LogoKachel } from '../../firma/komponenten/Logo';
import { istNativ } from '../../../gemeinsam/lib/plattform';
import { RECHTSLINKS } from '../lib/links';


/** Kleine Linkzeile für Fußbereiche (Startseite, Anmeldung, Registrierung, Tarif). */
export function RechtsLinks({ klasse = '' }: { klasse?: string }) {
  return (
    <nav className={`flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-500 dark:text-slate-400 ${klasse}`}>
      {RECHTSLINKS.map(([ziel, name]) => (
        <Link key={ziel} to={ziel} className="hover:text-slate-900 hover:underline dark:hover:text-white">{name}</Link>
      ))}
    </nav>
  );
}

export default function RechtsRahmen({ titel, stand, children }: { titel: string; stand?: string; children: ReactNode }) {
  return (
    <div
      style={{ paddingTop: 'calc(1.5rem + var(--sicher-oben))', paddingBottom: 'calc(2rem + var(--sicher-unten))' }}
      className="min-h-full bg-slate-50 px-4 dark:bg-slate-950">
      <div className="mx-auto max-w-3xl">
        <header className="mb-6 flex items-center gap-3">
          <LogoKachel />
          <Link to={istNativ() ? '/anmelden' : '/'} className="text-sm text-slate-500 hover:underline dark:text-slate-400">
            ← {istNativ() ? 'Zur Anmeldung' : 'Zur Startseite'}
          </Link>
        </header>
        <article className="rounded-2xl border border-slate-200 bg-white p-6 text-[15px] leading-relaxed text-slate-700 sm:p-10 dark:border-slate-800 dark:bg-slate-900 dark:text-slate-300
                            [&_a]:text-marke-600 [&_a]:underline dark:[&_a]:text-marke-400
                            [&_h2]:mt-8 [&_h2]:mb-2 [&_h2]:text-lg [&_h2]:font-semibold [&_h2]:text-slate-900 dark:[&_h2]:text-slate-100
                            [&_h3]:mt-5 [&_h3]:mb-1 [&_h3]:font-semibold [&_h3]:text-slate-900 dark:[&_h3]:text-slate-100
                            [&_li]:ms-5 [&_li]:list-disc [&_p]:mt-2 [&_ul]:mt-2 [&_ul]:space-y-1">
          <h1 className="text-2xl font-bold text-slate-900 dark:text-slate-100">{titel}</h1>
          {stand && <p className="!mt-1 text-sm text-slate-500 dark:text-slate-400">Stand: {stand}</p>}
          {children}
        </article>
        <RechtsLinks klasse="mt-6" />
      </div>
    </div>
  );
}
